import axios from "axios";
import { Pagination } from "../../interfaces/pagination";
import { User } from "../../models/db";



const apiUrl = process.env.REACT_APP_API_URL_MS_AUTH;

export class UserService {

  constructor() { }

  static get(id: any) {
    return axios.get(`${apiUrl}/api/user-${id}`, { withCredentials: true });
  }

  static getWithCompany(id: any, idCompany: any) {
    return axios.get(`${apiUrl}/api/user-${id}-company-${idCompany}`, { withCredentials: true });
  }

  static getAll(pagination?: Pagination) {
    return axios.post(`${apiUrl}/api/user`, { pagination }, { withCredentials: true });
  }

  // static getAllId(reasonForDesactivation: ReasonForDeactivationProps[] = []) {
  //   let object = { reasonForDesactivation };
  //   return axios.post(`${apiUrl}/api/user/all-id`, object, { withCredentials: true });
  // }

  static getFreeUserByIdCompany(idCompany: string, pagination: Pagination) {
    return axios.post(
      `${apiUrl}/api/user/free-by-company`,
      { idCompany, pagination },
      { withCredentials: true }
    );
  }

  // Nueva ruta para obtener usuarios por compañía y establecimiento
  static getUsersByCompanyAndEstablishment(
    idCompany: string,
    idEstablishment: string,
    pagination: Pagination
  ) {
    return axios.post(
      `${apiUrl}/api/user/by-company-and-establishment`,
      { idCompany, idEstablishment, pagination },
      { withCredentials: true }
    );
  }

  static add(body: User) {
    return axios.post(`${apiUrl}/api/user/add`, body, { withCredentials: true });
  }

  static update(body: User, myId: string) {
    // TODO: Se manda myId para controlar que quien cambia la contraseña es el mismo usuario
    return axios.post(`${apiUrl}/api/user/update`, { ...body, myId}, { withCredentials: true });
  }

  static updatePassword(id, password, myId) {
    // TODO: Se manda myId para controlar que quien cambia la contraseña es el mismo usuario
    let params = { id, password, myId };
    return axios.post(`${apiUrl}/api/user/update-password`, params, { withCredentials: true });
  }

  static delete(idList: string[] | number[], action: boolean) {

    let params = { idList, action };
    return axios.post(`${apiUrl}/api/user/delete`, params, { withCredentials: true });
  }

  static checkAdmin() {
    return axios.get(`${apiUrl}/api/user-admin`, { withCredentials: true });
  }

  static checkPassword(id, password) {
    let params = { id, password };
    return axios.post(`${apiUrl}/api/user/check-password`, params, { withCredentials: true });
  }

  static checkUsername(id, username) {
    // let params = { id, username };
    let params = { id, email: username };

    return axios.post(`${apiUrl}/api/user/check-username`, params, { withCredentials: true });
  }

  static checkEmail(id, email) {
    let params = { id, email };
    return axios.post(`${apiUrl}/api/user/check-email`, params, { withCredentials: true });
  }

  static autocompleteBack(query: string, itemsPerPage: number, field: string) {
    let params = { query, itemsPerPage, field };
    return axios.post(`${apiUrl}/api/user/autocomplete-back`, params, { withCredentials: true });
  }


  static autocompleteForCalendar() {
    return axios.get(`${apiUrl}/api/user/autocomplete-for-calendar`, { withCredentials: true });
  }


  static getUserList(idUserList: string[]) {
    let params = { idUserList };
    return axios.post(`${apiUrl}/api/users-by-list`, params, { withCredentials: true });
  }

  // Public = Sin necesidad de token
  // Public = Sin necesidad de token
  // Public = Sin necesidad de token
  // Public = Sin necesidad de token
  // Public = Sin necesidad de token

  static checkPasswordPublic(id, password) {

    let params = { id, password };
    return axios.post(`${apiUrl}/api/user/public-check-password`, params);
  }

  static checkUsernamePublic(id, username) {

    let params = { id, username };
    return axios.post(`${apiUrl}/api/user/public-check-username`, params);
  }

  static checkEmailPublic(id, email) {
    let params = { id, email };
    return axios.post(`${apiUrl}/api/user/public-check-email`, params);
  }


}
